export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11226.d82f39ad.jpg";